export const normalizeEstadoVerifactu = (estado) => {
  const rawState = String(estado ?? "").trim();
  if (!rawState || /^[-–—]+$/.test(rawState)) return "";

  return rawState
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\s-]+/g, "_")
    .toUpperCase();
};

export const isFacturaSubsanable = (estado) => [
  "ACEPTADA_CON_ERRORES",
  "DENEGADA",
].includes(normalizeEstadoVerifactu(estado));

export const getFacturaVerifactuAction = (estado) => {
  const normalizedState = normalizeEstadoVerifactu(estado);

  if (normalizedState === "ACEPTADA") return "accepted";
  if (isFacturaSubsanable(normalizedState)) return "subsanar";
  return "contact";
};

export const getVerifactuActionsForDocument = (documentType, estado) => {
  const isFactura = documentType === "Factura";
  const isRectificativa = ["F. Rectificativa", "Rectificativa"].includes(documentType);
  const normalizedState = normalizeEstadoVerifactu(estado);
  const hasState = normalizedState !== "";
  const action = getFacturaVerifactuAction(estado);
  const requiresAdministrator = [
    "FALLO_PROGRAMA",
    "FALLO_DEL_PROGRAMA",
    "PENDIENTE",
    "PENDIENTE_DE_ENVIO",
    "PENDIENTE_CONCILIACION",
    "PENDIENTE_DE_CONCILIACION",
    "REVISION_MANUAL",
    "REVISION_MANUAL_REQUERIDA",
  ].includes(normalizedState);
  const showAdminWarning = hasState && ((isFactura && action === "contact")
    || ((isFactura || isRectificativa) && requiresAdministrator));

  return {
    showRegularActions: !showAdminWarning && (!isFactura || !hasState || action === "accepted"),
    showSubsanar: isFactura && action === "subsanar",
    showAdminWarning,
  };
};
